// extracted by mini-css-extract-plugin
module.exports = {"formatted-text":"formatted-text__v3_El","bb":"bb__rP4_r","bb-text-with-table-content":"bb-text-with-table-content__HyCbq"};